

import { createSlice } from '@reduxjs/toolkit';


const initialState = {
	list: [],
	status: "dormant"
}




const rulesSlice = createSlice({
	name: 'rules',
	initialState,
	reducers: {
	
		setRules: (state, action) => {
			// console.log("action:", action);
			state.list = action.payload;
			state.status = 'dormant';
		},
		  
		setRulesStatus: (state, action) => {
			
			state.status = action.payload;
		}


	}
});

export const { setRules, setRulesStatus } = rulesSlice.actions;
export default rulesSlice.reducer;





